import { auth } from './firebase';

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || '';

export interface PixPaymentResponse {
  id: string;
  qr_code: string;
  qr_code_base64: string;
  ticket_url: string;
  status: string;
}

export const createPixPayment = async (productId: string, amount: number, description: string): Promise<PixPaymentResponse> => {
  const user = auth.currentUser;
  if (!user) throw new Error('Usuário não autenticado');

  const token = await user.getIdToken();

  const resp = await fetch(`${BACKEND_URL}/mercadopago/create-pix`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      userId: user.uid,
      email: user.email,
      amount,
      description,
      productId
    })
  });

  if (!resp.ok) {
    const error = await resp.json().catch(() => ({}));
    throw new Error(error.details || error.error || 'Falha ao gerar pagamento');
  }

  return resp.json();
};
